import { Grid } from "@mui/material"
import { ISettingsItem, useSettings } from "../../../Settings"
import { usePlan } from '../../../Plans'
import { useTranslation } from "../../../i18n"
import SwitchDefault from "../../SwitchDefault"

export default function SelectSmartControl({ name, variables }: ISettingsItem) {
  const { smartControl, setSmartControl } = usePlan()
  const { isSurfMVNE } = useSettings()
  const { t } = useTranslation()
  const { text } = variables || {}

  const defaultTextArray = [
    t.page2.smartControl.title,
    t.page2.smartControl.subtitle,
    t.page2.smartControl.bonusBadge,
    'flex',
  ]

  const mergedArray = text
    ? text.map((value, index) => (value !== undefined && value !== '' ? value : defaultTextArray[index]))
    : defaultTextArray

  const splitChoosePortabilityDetail = mergedArray[2].split(' ')

  const handleSwitchChange = () => {
    setSmartControl(!smartControl)
  }

  return (
    <Grid container item className={name ? `${name} select-smart-control` : "select-smart-control"} xs={12}>
      <Grid container item className="choosePortability" xs={12}>
        <Grid item className="choosePortabilitySwitch" style={{ display: mergedArray[3] }}>
          <SwitchDefault checked={smartControl} onChange={handleSwitchChange} />
        </Grid>
        <Grid item className="choosePortabilityText">
          <h3>{mergedArray[0]}</h3>
          <p>{mergedArray[1]}</p>
        </Grid>
        {/* Para MVNEs Surf não exibir o badge "+5GB GRÁTIS" */}
        {!isSurfMVNE && (
          <Grid item className="choosePortabilityDetail">
            <p>{splitChoosePortabilityDetail[0]} <span>{splitChoosePortabilityDetail[1]}</span></p>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}